// 开发环境配置
module.exports = {
  // php 接口地址
  phpUrl: '',
  // java 接口地址
  javaUrl: 'https://api.dokiisland.com',
  // socket 地址
  socketUrl: 'ws://139.224.230.52:9326'
}
